import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Portfolio from './components/Portfolio';
import CategoryPage from './components/pages/CategoryPage';
import ProjectPage from './components/pages/ProjectPage';
import ContactPage from './components/pages/ContactPage';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/graphic-design" element={<CategoryPage />} />
          <Route path="/graphic-design/:projectId" element={<ProjectPage />} />
          <Route path="/ui-ux" element={<CategoryPage />} />
          <Route path="/ui-ux/:projectId" element={<ProjectPage />} />
          <Route path="/ai-creative" element={<CategoryPage />} />
          <Route path="/ai-creative/:projectId" element={<ProjectPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
